import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { stylingHelpers } from '../../designTokens';

const { fixAll, flexCenter } = stylingHelpers;

const baseStyles = ({ theme }) => css`
  ${fixAll()}
  z-index: ${theme.zIndex.modal};
  padding-right: 24px;
  padding-left: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #3f2021;
  opacity: 0.66;
`;

const Container = styled('div')(baseStyles);

const wrapperBaseStyles = ({ theme }) => css`
  background: ${theme.colors.n300};
  opacity: 1;
  overflow: auto;
  height: 272px;
  border-radius: 12px;
  width: 100%;
`;

const Wrapper = styled('div')(wrapperBaseStyles);

const modalPrimaryBaseStyles = () => css`
  ${flexCenter()}
`;

const ModalPrimary = styled('div')(modalPrimaryBaseStyles);

const modalSecondaryBaseStyles = () => css``;

const ModalSecondary = styled('div')(modalSecondaryBaseStyles);

const Modal = ({ primaryContent, secondaryContent }) => (
  <Container>
    <Wrapper>
      {primaryContent && <ModalPrimary>{primaryContent}</ModalPrimary>}
      {secondaryContent && <ModalSecondary>{secondaryContent}</ModalSecondary>}
    </Wrapper>
  </Container>
);

Modal.propTypes = {
  primaryContent: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  secondaryContent: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default Modal;
